import axios from 'axios';
import Vue from 'vue';

const state = {
    active: null,
    questions: new Map()
};

const mutations = {
    load(state, chapter){
        state.active = chapter;
        state.questions = new Map();

        //NOTE May not exist for the teacher at the moment, until we're loading student results.
        if(chapter.questions){
            for(const question of chapter.questions){
                state.questions.set(question.component_id, question);
            }
        }
    },
    attempt(state, attempt){
        if(state.questions.has(attempt.component_id)){
            state.questions.get(attempt.component_id).attempts.push(attempt);
        }else{
            console.warn('Question not found for the created attempt.');
        }
    },
    submit(state, submission){
        //TODO Maybe add other information from the submission object like total points.
        state.active.submission_state = 'submitted';
    }
};

const actions = {
    load({commit, state, dispatch}, {product_id, assignment_id}){
        return axios.get(`/products/${product_id}/assignments/${assignment_id}`).then(response => commit('load', response.$data));
    },
    attempt({commit}, attempt){
        commit('attempt', attempt);
    },
    submit({commit, state}){
        if(state.active){
            return axios.post(`/products/${state.active.product_id}/assignments/${state.active.assignment_id}/submit`).then(response => commit('submit', response.$data));
        }

        return Promise.reject('There is no active assignment.');
    },
    simulation({commit}, event){

    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
